import React from 'react';
import '../template-file-css/document-file-template.css';


export const JHC_AdultClientFreedomChoice = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='JHC_AdultClientFreedomChoice' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'>
                    <b> <center> Client Freedom of Choice </center> </b>
                </p>
                <p className='w-750'>
                    <b>Freedom of Choice - Section I -  Identifying Information  </b>
                </p>
                <table>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Client Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>DOB:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>  <input id='txtClientName' name='txtClientName' type='text' className='add-only' /> </td>
                        <td className='w-375'> <input type='date' id='txtClientDob' name='txtClientDob' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Are you currently receiving behavioral health services with another provider?</span>
                    <input type='radio' id='rbBehavioralHealthServices_Yes' name='rbBehavioralHealthServices' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbBehavioralHealthServices_No' name='rbBehavioralHealthServices' className='add-only' value='No' /> No if yes please complete the following section.
                </p>
                <p className='w-750'>
                    The provider is responsible for coordinating care if a client has a previous provider.
                    <span className='eleHeader'>Name of previous provider is applicable:</span>
                    <input id='txtNamePreviousProvider' name='txtNamePreviousProvider' type='text' className='add-only' />

                </p>
                <p className='w-750'>

                    I, <input id='txtSectionClientName' name='txtSectionClientName' type='text' className='add-only custom-add-only w-250' /> I have selected to receive behavioral health services with the following:  I have chosen the following provider(s) and service(s)  <b>Provider: Jackson Hands of Change 4035 Washington Avenue New Orleans, LA 70125 effective</b> <input id='txtSectionEffectiveDate' name='txtSectionEffectiveDate' type='date' className='add-only custom-add-only w-150' /> .
                    <b> Phone 504-535-5082 Fax ' 877-250-2283</b>

                </p>
                <p className='w-750'>
                    <b>Freedom of Choice - Section II</b>
                </p>
                <p className='w-750'>
                    I understand that I have a choice in accepting and choosing behavioral health services. I understand that I have a choice of providers for myself/child and between which services I may be eligible to receive. These services have been explained to me, and a listing of service providers in my area has been made available to me. I understand that I may only receive MHR services form one provider.
                </p>
                <p className='w-750'>
                    If assistance is needed with finding an MHR provider, review the list of providers located at your health plan's website below or call your plan for assistance. 1. Aetna: https://www.aetnabetterhealth.com/louisiana/find-provider or call 1-855-242-0802 Hearing impaired TTY/TDD 711 2. Amerihealth Caritas Louisiana:
                    http://www.amerihealthcaritasla.com/member/eng/tools/find-provider.aspx or call 1-888-756-0004; TTY 1-866-428-7588 3. Healthy Blue: https://www.myhealthybluela.com/la/care/find-a-doctor.html or call 1-844-227-8350 (TTY 711) 4. Louisiana:
                </p>
                <p className='w-750'>
                    http://www.amerihealthcaritasla.com/member/eng/tools/find-provider.aspx or call 1-888-756-0004; TTY 1-866-428-7588 3. Healthy Blue: https://www.myhealthybluela.com/la/care/find-a-doctor.html or call 1-844-227-8350 (TTY 711) 4. Louisiana
                    Healthcare Connections: https://providersearch.louisianahealthconnect.com/ or call 1-866-595- 8133 (Hearing Loss: 711) 5. United Healthcare Community: http://www.uhccommunityplan.com/la/medicaid/healthy-louisiana.html or call 1-866-6751607 TTY: 1-877-4285-4514
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>I would like to receive:</span>
                            <span className='small'>(Check all that apply)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>  <input type='checkbox' id='cbReceive_1' name='cbReceive_1' className='add-only' value='Receive_1' /> CPST </td>
                        <td className='w-250'>  <input type='checkbox' id='cbReceive_2' name='cbReceive_2' className='add-only' value='Receive_2' /> PSR </td>
                        <td className='w-250'>  <input type='checkbox' id='cbReceive_3' name='cbReceive_3' className='add-only' value='Receive_3' /> Psychotherapy </td>
                    </tr>
                    <tr>
                        <td className='w-250'>  <input type='checkbox' id='cbReceive_4' name='cbReceive_4' className='add-only' value='Receive_4' /> Diagnostic Assessment </td>
                        <td className='w-250'>  <input type='checkbox' id='cbReceive_5' name='cbReceive_5' className='add-only' value='Receive_5' /> Medication Management </td>
                        <td className='w-250'>  <input type='checkbox' id='cbReceive_6' name='cbReceive_6' className='add-only' value='Receive_6' /> Physician Evaluation Assessment </td>
                    </tr>
                    <tr>
                        <td className='w-250'>  <input type='checkbox' id='cbReceive_7' name='cbReceive_7' className='add-only' value='Receive_7' /> Treatment Planning </td>
                        <td className='w-250'>  <input type='checkbox' id='cbReceive_8' name='cbReceive_8' className='add-only' value='Receive_8' /> Individual Counseling </td>
                        <td className='w-250'>  <input type='checkbox' id='cbReceive_9' name='cbReceive_9' className='add-only' value='Receive_9' /> Family Counseling </td>
                    </tr>
                    <tr>
                        <td className='w-250'>  <input type='checkbox' id='cbReceive_10' name='cbReceive_10' className='add-only' value='Receive_10' /> Group Counseling </td>
                        <td className='w-250'>  <input type='checkbox' id='cbReceive_11' name='cbReceive_11' className='add-only' value='Receive_11' /> Psycho-education </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReceive_12' name='cbReceive_12' className='add-only' value='Receive_12' /> Other:
                            <input id='txtReceive_12Other' name='txtReceive_12Other' type='text' className='add-only' />
                        </td>
                    </tr>

                </table>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Print  Client Name </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Agency Representative </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature of Client, Guardian or Personal Representative  </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>


            </div>
        </form>

    )
}